import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DenialPromptModal from './DenialPromptModal';
import DenialFormModal from './DenialFormModal';

/**
 * BenefitDenialModal component.
 * Orchestrate the two-step "Negativa de Concessão de Benefício" flow:
 * (1) prompt asking the user whether to continue or issue a denial,
 * (2) form to collect beneficiary data and submit the request.
 *
 * @param {object} props - origin, destination, date, category.
 * @param {object} props.origin - Selected origin place ({ id, ... }).
 * @param {object} props.destination - Selected destination place ({ id, ... }).
 * @param {string} props.date - Selected travel date (YYYY-MM-DD).
 * @param {string} props.category - Selected benefit category.
 * @param {boolean} props.halfFareAvailable - Whether the half-fare (50%) equivalent is available,
 *   so the prompt offers buying at 50% as an alternative to issuing the denial.
 * @returns {JSX.Element|null} The rendered modal step or null when dismissed.
 */
const BenefitDenialModal = ({ origin, destination, date, category, halfFareAvailable }) => {
  const [step, setStep] = useState('prompt');

  if (step === 'closed') return null;

  if (step === 'form') {
    return (
      <DenialFormModal
        tripContext={{
          origin: origin?.id,
          destination: destination?.id,
          date,
          category,
        }}
        onClose={() => setStep('closed')}
        onSuccess={() => setStep('closed')}
      />
    );
  }

  return (
    <DenialPromptModal
      date={date}
      halfFareAvailable={halfFareAvailable}
      onClose={() => setStep('closed')}
      onContinueShopping={() => setStep('closed')}
      onIssueDenial={() => setStep('form')}
    />
  );
};

BenefitDenialModal.propTypes = {
  origin: PropTypes.object,
  destination: PropTypes.object,
  date: PropTypes.string,
  category: PropTypes.string,
  halfFareAvailable: PropTypes.bool,
};

export default BenefitDenialModal;
